import PropTypes from "prop-types";
import React from "react";
import { formatDate } from "../../../lib/datetime_formatters";
import Button from "../../ui/Button";
import { formatCurrency } from "../../../lib/currency";

const MobileCard = ({ recycledInquiry, onOpenModal, currentLocale }) => {
  const {
    id,
    inquired_at,
    city,
    currency,
    country_code,
    budget_min,
    budget_max,
    kind_of_art,
    service_type,
    kind_of_moment,
    occasion_date,
    date,
  } = recycledInquiry;

  const countryCode =
    country_code !== undefined ? country_code.toLowerCase() : "none";
  const country = I18n.t(`country.${countryCode}`);

  let budget = "-";
  if (budget_min && budget_max) {
    budget = `${formatCurrency(
      currentLocale,
      currency,
      budget_min
    )} - ${formatCurrency(currentLocale, currency, budget_max)}`;
  } else if (budget_min) {
    budget = `${formatCurrency(currentLocale, currency, budget_min)}+`;
  } else if (budget_max) {
    budget = `0 - ${formatCurrency(currentLocale, currency, budget_max)}`;
  }

  return (
    <div className="b-job-board__mobile-card" key={id}>
      <div className="b-job-board__mobile-card-header">
        <div className="b-job-board__mobile-card-date">
          {formatDate(inquired_at)}
        </div>
        <div className="b-job-board__mobile-card-location">
          {city}, {country}
        </div>
      </div>

      <div className="b-job-board__mobile-card-content">
        <div className="b-job-board__mobile-card-row">
          <span className="b-job-board__mobile-card-label">
            {I18n.t("recycled_inquiries.index.table.kind_of_art")}:
          </span>
          <span className="b-job-board__mobile-card-value">
            {kind_of_art
              ? I18n.t(`categories.${kind_of_art}`, {
                  defaultValue: kind_of_art,
                })
              : "-"}
          </span>
        </div>

        <div className="b-job-board__mobile-card-row">
          <span className="b-job-board__mobile-card-label">
            {I18n.t("recycled_inquiries.index.table.service_type")}:
          </span>
          <span className="b-job-board__mobile-card-value">
            {service_type
              ? I18n.t(`subtypes.${service_type}`, {
                  defaultValue: service_type,
                })
              : "-"}
          </span>
        </div>

        <div className="b-job-board__mobile-card-row">
          <span className="b-job-board__mobile-card-label">
            {I18n.t("recycled_inquiries.index.table.occasion")}:
          </span>
          <span className="b-job-board__mobile-card-value">
            {kind_of_moment ? I18n.t(`kinds_of_moment.${kind_of_moment}`) : "-"}
          </span>
        </div>

        <div className="b-job-board__mobile-card-row">
          <span className="b-job-board__mobile-card-label">
            {I18n.t("recycled_inquiries.index.table.event_date")}:
          </span>
          <span className="b-job-board__mobile-card-value">
            {formatDate(occasion_date) || formatDate(date) || "-"}
          </span>
        </div>

        <div className="b-job-board__mobile-card-row">
          <span className="b-job-board__mobile-card-label">
            {I18n.t("recycled_inquiries.index.table.budget")}:
          </span>
          <span className="b-job-board__mobile-card-value">{budget}</span>
        </div>
      </div>

      <div className="b-job-board__mobile-card-actions">
        <Button
          classOverride="inline-button inline-button--orange"
          onClick={() => onOpenModal(recycledInquiry)}
        >
          {I18n.t("recycled_inquiries.index.inquiry_modal.see_inquiry")}
        </Button>
      </div>
    </div>
  );
};

MobileCard.propTypes = {
  recycledInquiry: PropTypes.shape({
    id: PropTypes.number.isRequired,
    inquired_at: PropTypes.string.isRequired,
    country_code: PropTypes.string,
    city: PropTypes.string.isRequired,
    kind_of_art: PropTypes.string.isRequired,
    service_type: PropTypes.string.isRequired,
    kind_of_moment: PropTypes.string.isRequired,
    occasion_time: PropTypes.string.isRequired,
    occasion_date: PropTypes.string,
    date: PropTypes.string.isRequired,
    budget_min: PropTypes.number.isRequired,
    budget_max: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  onOpenModal: PropTypes.func.isRequired,
  currentLocale: PropTypes.string.isRequired,
};

export default MobileCard;
